module.exports = __webpack_public_path__ + "img/44_ProLabel_PA66.0af3fc1a.png";